<div *ngIf="socio$ | async as socio" class="section">
  <ng-container *ngIf="socio && socio.idGestore">
    <div class="notification is-primary">
      <p class="has-text-centered"><span i18n="@@memberManageBy">Socio gestito da</span> {{socio.nomeGestore}}</p>
    </div>
  </ng-container>
  <ng-container *ngIf="socio && !socio.idGestore">

    <div class="example-loading-shade"
         *ngIf="isLoadingResults || isRateLimitReached">
      <nwb-spinner *ngIf="isLoadingResults" color="#4baed0"></nwb-spinner>
    </div>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="title" i18n="@@members">Soci</div>
        </div>
        <div class="level-item">
          <a class="button is-primary is-outlined" [routerLink]="['./', 'aggiungi']" i18n="@@add">Aggiungi</a>
        </div>
      </div>
      <!--<div class="level-right">
        <div class="level-item">
          <a class="button is-link" [routerLink]="['./', 'aggiungi']"><i class="fas fa-plus is-inverted"></i></a>
        </div>
      </div>-->
    </div>
    <ng-container *ngIf="soci && soci.length > 0; else sezVuotaSociGestiti">
      <div class='columns is-mobile is-multiline '>
        <div *ngFor="let socio of soci" class='column is-3-fullhd is-4-widescreen is-4-desktop is-6-tablet is-12-mobile'>
          <div class="card bm--card-equal-height">
            <div class="card-content">
              <div class="media">
                <div class="media-left">
                  <figure class="image is-48x48">
                    <type-socio [entita]="socio" [size]="3"></type-socio>
                  </figure>
                </div>
                <div class="media-content">
                  <p class="title is-4">{{socio.nome1}}<br />{{socio.nome2}}</p>
                </div>
              </div>
              <div class='content'>
                <p class="subtitle is-6"><span i18n="@@memberMyGroup">Socio</span>&nbsp;{{socio | tipoSocio}}</p>
                <div class="columns is-vcentered">
                  <div class="column is-narrow">
                    <div class="tags">
                      <span class="tag is-danger" *ngIf="socio.ko" i18n="@@deactivated" >Disattivato</span>
                      <ng-container *ngIf="!socio.ko">
                        <span class="tag is-warning" *ngIf="socio.temporary; else socioAttivato" i18n="@@notActivated" >Temporaneo</span>
                        <ng-template #socioAttivato>
                          <span *ngIf="socio | assicurato; else noAssicurato" class="tag is-success" i18n="@@insured" >Assicurato</span>
                          <ng-template #noAssicurato><span class="tag is-danger" i18n="@@notInsured" >Non assicurato</span></ng-template>
                          <span *ngIf="socio.newsletter" class="tag is-primary">Newsletter</span>
                        </ng-template>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="columns is-marginless is-gapless" *ngIf="socio.fineValidita">
                  <div class="column">
                    <span class="has-text-weight-semibold" i18n="@@insuranceExpireMyGroup">Scadenza:</span>&nbsp;{{socio.fineValidita | date}}
                  </div>
                </div>
                <div *ngIf="socio.nomeAssociazione" class="columns is-marginless is-gapless">
                  <div class="column">
                    <span class="has-text-weight-semibold" i18n="@@association" >Associazione</span>:&nbsp;{{socio.nomeAssociazione}}
                  </div>
                </div>
                <div *ngIf="socio.natoIl" class="columns is-marginless is-gapless">
                  <div class="column">
                    <span class="has-text-weight-semibold" i18n="@@birthDate">Data nascita</span>:&nbsp;{{socio.natoIl | date}}
                  </div>
                </div>
                <div class="columns" style="margin-top: 1em">
                  <div class="column">
                    <span class="has-text-weight-semibold" i18n="@@idGroup">Id:</span>&nbsp;{{socio.id}}
                  </div>
                  <div class="column has-text-right" *ngIf="socio.idTessera">
                    <span class="has-text-weight-semibold" i18n="@@card">Tessera</span>:&nbsp;{{socio.idTessera}}
                  </div>
                </div>
              </div>
            </div>
            <footer class='card-footer'>
              <a  [routerLink]="['./', 'modifica', socio.id]" class='card-footer-item' i18n="@@modify">Modifica</a>
              <a (click)="rimuovi(socio)" class='card-footer-item' i18n="@@remove" >Rimuovi</a>
            </footer>
          </div>
          <br>
        </div>
      </div>
    </ng-container>
    <ng-template #sezVuotaSociGestiti>
      <div i18n="@@nomemberAvailable" class="has-text-centered-mobile">Nessun socio disponibile</div>
    </ng-template>

    <hr />

    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="title" i18n="@@loyalFriends">Amici fedeli</div>
        </div>
        <div class="level-item">
          <a class="button is-primary is-outlined" i18n="@@add" [routerLink]="['./', 'aggiungi-amico-fedele']">Aggiungi</a>
        </div>
      </div>
      <!--<div class="level-right">
        <div class="level-item">
          <a class="button is-link" [routerLink]="['./', 'aggiungi-amico-fedele']"><i class="fas fa-plus is-inverted"></i></a>
        </div>
      </div>-->
    </div>
    <ng-container *ngIf="amiciFedeli && amiciFedeli.length > 0; else sezVuotaAmiciFedeli">
      <div class='columns is-mobile is-multiline '>
        <div *ngFor="let amicoFedele of amiciFedeli" class='column is-3-fullhd is-4-widescreen is-4-desktop is-6-tablet is-12-mobile'>
          <div class="card bm--card-equal-height">
            <div class="card-content">
              <div class="media">
                <div class="media-left">
                  <figure class="image is-48x48">
                    <i class="fas fa-paw fa-3x"></i>
                  </figure>
                </div>
                <div class="media-content">
                  <p class="title is-4">{{amicoFedele.nome}}</p>
                </div>
              </div>
              <div class="content">
                <p class="subtitle is-6" i18n="@@loyalFriend">Amico fedele</p>
                <div class="columns is-vcentered">
                  <div class="column is-narrow">
                    <div class="tags">
                      <span class="tag is-danger" *ngIf="amicoFedele.ko" i18n="@@deactivated" >Disattivato</span>
                      <ng-container *ngIf="!amicoFedele.ko">
                        <span class="tag is-warning" *ngIf="amicoFedele.temporary; else amicoFedeleAttivato" i18n="@@notActivated" >Non attivato</span>
                        <ng-template #amicoFedeleAttivato>
                          <span *ngIf="amicoFedele | assicurato; else noAssicurato" class="tag is-success" i18n="@@insured" >Assicurato</span>
                          <ng-template #noAssicurato><span class="tag is-danger" i18n="@@notInsured" >Non assicurato</span></ng-template>
                        </ng-template>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="columns is-marginless is-gapless" *ngIf="amicoFedele.fineValidita">
                  <div class="column">
                    <span class="has-text-weight-semibold" i18n="@@insuranceExpire">Scadenza:</span>&nbsp;{{amicoFedele.fineValidita | date}}
                  </div>
                </div>
                <div *ngIf="amicoFedele.razza" class="columns is-marginless is-gapless">
                  <div class="column">
                    <span class="has-text-weight-semibold" i18n="@@breed">Razza</span>:&nbsp;{{amicoFedele.razza}}
                  </div>
                </div>
                <div class="columns" style="margin-top: 1em">
                  <div class="column">
                    <span class="has-text-weight-semibold" i18n="@@idGroup">Id:</span>&nbsp;{{amicoFedele.id}}
                  </div>
                </div>
              </div>
            </div>
            <footer class='card-footer'>
              <a class='card-footer-item' [routerLink]="['./', 'modifica-amico-fedele', amicoFedele.id]" i18n="@@modify">Modifica</a>
              <a (click)="rimuovi(amicoFedele)" class='card-footer-item' i18n="@@remove">Rimuovi</a>
            </footer>
          </div>
          <br>
        </div>
      </div>
    </ng-container>
    <ng-template #sezVuotaAmiciFedeli>
      <div i18n="@@noLoaylFriendAvailable" class="has-text-centered-mobile" >Nessun amico fedele disponibile</div>
    </ng-template>

  </ng-container>


</div>
